export type OpticalAlignment = "start" | "end" | "top" | "bottom" | "x" | "y" | "all";

const opticalAlignMap: Record<OpticalAlignment, string> = {
  start: "visual-align-start",
  end: "visual-align-end",
  top: "visual-align-top",
  bottom: "visual-align-bottom",
  x: "visual-align-start visual-align-end",
  y: "visual-align-top visual-align-bottom",
  all: "visual-align-start visual-align-end visual-align-top visual-align-bottom",
};

export function getOpticalAlignClasses(
  value?: OpticalAlignment | OpticalAlignment[],
): string | undefined {
  if (!value) return undefined;
  const values = Array.isArray(value) ? value : [value];
  return values.map(v => opticalAlignMap[v]).join(" ");
}
